module.exports = __webpack_public_path__ + "static/img/vietnam.e4d5029.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/vietnam.jpg
// module id = 0/tJ
// module chunks = 1